<template>
  <div>
    <el-card shadow="always">
      <header class="header-global" v-if="anonymous">
        <el-row :gutter="5">
          <el-col :span="2">
          <img
            :src="logo"
            class="mobile"
            alt="logo"
            height="40px" />
          <img
            :src="logo"
            class="logo"
            alt="logo"
            height="40px" />
          </el-col>
          <el-col :offset="1" :span="20">
          <h4>{{ $t('consulta-objetos-sro') }}</h4>
          </el-col>
        </el-row>
      </header>
      <el-page-header
        v-else
        title="Home"
        @back="$router.push( {name: back })"
        :content="$t('consulta-objetos-sro')"
      ></el-page-header>
    </el-card>
    <el-card>
      <!-- Rótulo, campo e botão na mesma linha. Sem el-form/el-form-item: eles
           empilhavam o rótulo e somavam 22px de margem inferior. -->
      <div class="me-sro-search">
        <span class="me-sro-search__label">
          {{ $t("objeto") }}
          <el-tooltip placement="top">
            <div slot="content">
              Separe vários códigos por <b>;</b> vírgula ou quebra de linha.<br />
              <b>Enter</b> ou <b>Ctrl+Enter</b> pesquisa &middot;
              <b>Shift+Enter</b> quebra linha &middot;
              <b>Esc</b> limpa
            </div>
            <i class="el-icon-info me-sro-search__info"></i>
          </el-tooltip>
        </span>
        <el-input
          placeholder="MASV123456789000BR; MASV987654321000BR"
          v-model="object"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 6 }"
          ref="tag"
          class="uppercase me-sro-search__input"
          @keydown.native="onKey"
        >
        </el-input>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          class="me-sro-search__btn"
          @click="fetchRecord"
          >{{ $t("pesquisar") }}</el-button
        >
      </div>
      <el-tabs
        v-if="tags.length > 1"
        tab-position="left"
        v-model="active"
        closable
        class="me-sro-tabs"
        @tab-remove="removeTab"
      >
        <el-tab-pane
          v-for="item in tags"
          :key="item"
          :label="item"
          :name="item"
        >
          <ObjectSroDetail v-bind:tag="item" />
        </el-tab-pane>
      </el-tabs>
      <ObjectSroDetail v-else-if="tags.length === 1" v-bind:tag="tags[0]" />
    </el-card>
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import ObjectSroDetail from "./ObjectSroDetail";
import config from "@/sites/config.json"

export default {
  name: "ObjectSro",
  components: {
    ObjectSroDetail,
  },
  data() {
    return {
      user: {
        type: "0",
      },
      site: config["default"],
      selectedFont: "Avenit",
      anonymous: false,
      active: "",
      object: "",
      tags: [],
      back: 'home',
    };
  },
  methods: {
    /**
     * Teclado do campo de busca:
     *   Enter / Ctrl+Enter -> pesquisa
     *   Shift+Enter        -> quebra de linha (o campo é textarea)
     *   Esc                -> limpa
     */
    onKey(event) {
      if (event.key === "Enter") {
        const forcar = event.ctrlKey || event.metaKey;
        if (event.shiftKey && !forcar) return;
        event.preventDefault();
        return this.fetchRecord();
      }
      if (event.key === "Escape") {
        event.preventDefault();
        this.object = "";
      }
    },
    focusInput() {
      const wrapper = this.$refs.tag;
      const field = wrapper && wrapper.$el.querySelector("textarea, input");
      if (field) field.focus();
    },
    fetchRecord() {
      const vm = this;

      // Aceita ; , espaço e quebra de linha: quem cola uma coluna de planilha ou
      // uma lista de e-mail não precisa reformatar nada.
      const codes = (vm.object || "")
        .split(/[;,\s]+/)
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean);

      if (!codes.length) {
        return vm.$message({
          type: "error",
          message: "Objeto não informado!",
        });
      }

      for (const tag of codes) {
        if (vm.tags.indexOf(tag) === -1) {
          vm.tags.push(tag);
        }
      }

      vm.active = codes[0];
      vm.object = "";
      vm.focusInput();
    },
    removeTab(targetName) {
      const vm = this;
      const index = vm.tags.findIndex((x) => x === targetName);
      vm.tags.splice(index, 1);
      if (vm.tags.length > 0) {
        vm.active = vm.tags[0];
      }
    },
  },
  computed: {
    logo() {
      return this.site.pages.login.logo
    }
  },
  mounted() {
    const vm = this;
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'default';
    vm.site = config[site] || config['default'];

    UserService.me().then((response) => {
      vm.user.type = response.type;
    }).catch(e => {
      vm.anonymous = true;
    });
    if (vm.$route.query.back) { 
      vm.back = vm.$route.query.back;
    }
    if (vm.$route.params.tag) {
      vm.tags.push(this.$route.params.tag);
      vm.active = this.$route.params.tag;
    } else {
      vm.focusInput();
    }
  },
};
</script>

<style scoped>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
.me-sro-search {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 30px;
}
.me-sro-search__label {
  flex: 0 0 auto;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}
.me-sro-search__info {
  color: #c0c4cc;
  cursor: help;
}
.me-sro-search__input {
  flex: 1 1 auto;
  min-width: 0;
}
/* Sem isto o textarea nasce ~33px contra 32px do botão: a primeira linha fica
   fora do eixo do rótulo. */
.me-sro-search__input >>> .el-textarea__inner {
  min-height: 32px;
  line-height: 22px;
  padding: 4px 11px;
}
.me-sro-search__btn {
  flex: 0 0 auto;
}
.me-sro-search__btn.el-button--primary {
  background-color: #22418d;
  border-color: #22418d;
}
.me-sro-search__btn.el-button--primary:hover,
.me-sro-search__btn.el-button--primary:focus {
  background-color: #1b3470;
  border-color: #1b3470;
}
/* Trilho das etiquetas consultadas.
   O estilo "card" do Element pinta `border-right-color:#fff` na aba ativa para
   ela emendar no painel; quando o fundo ao lado não é branco isso vira um rasgo.
   Aqui a seleção é comunicada por cor, peso e a barra da marca — sem molduras. */
.me-sro-tabs >>> .el-tabs__header.is-left {
  margin-right: 0px;
}
.me-sro-tabs >>> .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  background-color: #ebeef5;
}
.me-sro-tabs >>> .el-tabs__active-bar.is-left {
  width: 2px;
  background-color: #22418d;
}
.me-sro-tabs >>> .el-tabs__item.is-left {
  height: 36px;
  line-height: 36px;
  padding: 0 18px 0 12px;
  font-size: 13px;
  color: #606266;
  text-align: left;
  border-radius: 4px 0 0 4px;
  transition: background-color 0.2s, color 0.2s;
}
.me-sro-tabs >>> .el-tabs__item.is-left:hover {
  color: #22418d;
  background-color: #f5f7fa;
}
.me-sro-tabs >>> .el-tabs__item.is-left.is-active {
  color: #22418d;
  font-weight: 500;
  background-color: #f0f3f9;
}
.me-sro-tabs >>> .el-tabs__item .el-icon-close {
  color: #c0c4cc;
}
.me-sro-tabs >>> .el-tabs__item .el-icon-close:hover {
  color: #fff;
  background-color: #f25c5c;
}
</style>
